import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const MessageGraphic: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 133 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M123.44 13.6363C17.9923 13.8872 23.5465 13.0559 20.3169 14.2725C14.8563 14.3062 11.5307 20.2616 10.433 23.2825C8.65453 28.1777 8.96681 33.5464 9.1978 38.7496C9.87354 53.9726 9.65246 69.2357 8.53593 84.4329C8.16318 89.5064 8.97499 95.0539 12.4481 98.771C15.894 102.459 20.5189 102.813 25.5653 102.72C37.603 102.498 49.6407 102.275 61.6784 102.053C63.1676 103.335 65.4893 105.833 65.955 106.256C75.1331 114.592 80.7286 120.995 87.9529 119.872C90.2834 120.034 92.0968 118.46 92.5115 116.423C93.7312 110.375 94.9624 104.013 96.1787 97.6448H123.44C128.704 97.6448 132.987 93.3621 132.987 88.0979V23.1831C132.987 17.919 128.704 13.6363 123.44 13.6363ZM129.942 88.0979C129.942 91.6827 127.025 94.5993 123.44 94.5993C93.4219 94.6258 94.4412 94.3478 93.7639 95.1639C93.2277 95.8128 93.64 95.4597 89.5255 115.819C89.3167 116.851 88.0201 117.229 87.2969 116.429C85.4287 114.362 83.0894 111.746 82.3242 111.042L82.354 111.014C66.2812 93.6561 68.7671 95.63 67.1305 95.0494H23.659C20.0742 95.0494 17.1576 92.1328 17.1576 88.546V23.1831C17.1576 19.5983 20.0742 16.6817 23.659 16.6817H123.44C127.025 16.6817 129.942 19.5983 129.942 23.1831V88.0979Z"
        fill="currentColor"
      />
      <path
        d="M122.459 37.9209H31.693C30.8523 37.9209 30.1703 38.603 30.1703 39.4436C30.1703 40.2843 30.8523 40.9664 31.693 40.9664H122.459C123.299 40.9664 123.981 40.2843 123.981 39.4436C123.981 38.603 123.299 37.9209 122.459 37.9209Z"
        fill="currentColor"
      />
      <path
        d="M92.9299 60.1116H41.8011C40.9604 60.1116 40.2783 60.7936 40.2783 61.6343C40.2783 62.475 40.9604 63.1571 41.8011 63.1571H92.9299C93.7706 63.1571 94.4526 62.475 94.4526 61.6343C94.4526 60.7936 93.7706 60.1116 92.9299 60.1116Z"
        fill="currentColor"
      />
      <path
        d="M75.4184 75.4937H62.6734C61.8327 75.4937 61.1506 76.1757 61.1506 77.0164C61.1506 77.8571 61.8327 78.5391 62.6734 78.5391H75.4184C76.2591 78.5391 76.9412 77.8571 76.9412 77.0164C76.9412 76.1757 76.2591 75.4937 75.4184 75.4937Z"
        fill="currentColor"
      />
      <path
        d="M1.13709 16.2714C6.22114 17.6098 7.45721 18.9164 8.42365 18.9164C10.0298 18.9164 10.536 16.7448 9.10571 16.0315C6.81565 14.8895 4.39671 13.9794 1.91036 13.3251C1.09149 13.1109 0.264687 13.5987 0.0505511 14.4116C-0.163585 15.2245 0.322186 16.0573 1.13709 16.2714Z"
        fill="currentColor"
      />
      <path
        d="M13.6184 14.8278C14.3322 14.3837 14.5483 13.4439 14.1022 12.7301C12.3574 9.93643 10.2517 7.38266 7.83875 5.1382C7.22211 4.56321 6.2585 4.5989 5.68748 5.21553C5.11447 5.83018 5.14817 6.79379 5.7648 7.3668C7.97952 9.42885 9.91665 11.7764 11.5207 14.3441C11.9571 15.0453 12.8908 15.2804 13.6184 14.8278Z"
        fill="currentColor"
      />
      <path
        d="M18.2839 11.2372C18.9342 11.2372 19.537 10.8188 19.7392 10.1645C20.6374 7.2618 20.7682 4.1608 20.1219 1.19462C19.9434 0.37377 19.1345 -0.137776 18.3096 0.0327398C17.4888 0.211186 16.9673 1.02213 17.1478 1.84496C17.6811 4.29761 17.5721 6.86327 16.8285 9.26436C16.5273 10.2404 17.2568 11.2372 18.2839 11.2372Z"
        fill="currentColor"
      />
    </svg>
  )
})

MessageGraphic.displayName = 'MessageGraphic'
